import { UnstyledButton } from "@mantine/core";
import { Mic, X } from "lucide-react";

import classes from "../../../platform/media/slots.module.css";

/** A voice profile the draft names, with the name its list gives it once read. */
export interface PickedVoice {
  id: string;
  name: string;
}

export interface VoicesProps {
  /** The voices picked, in their `@Voice1` order. */
  voices: PickedVoice[];
  /** The model's block tags voices: each shows its `@Voice1`. */
  tagged: boolean;
  /** The inputs chosen leave no mode that takes voices: the tile greys. */
  disabled: boolean;
  /** Opens the Voice Settings panel (layout A, spec G2-kling-v4-voices). */
  onOpen: () => void;
  onRemove: (id: string) => void;
}

/**
 * Kling 4.0's voices (spec G2-kling-v4-voices, layout A, Daniil 2026-11-03; live has none): each
 * picked voice a filled slot with its name, its `@Voice1` and an x, then the Voices tile, which
 * opens the Voice Settings panel. Shown only where a mode of the model takes voices.
 */
export function VoicesSlot({ voices }: { voices: VoicesProps }) {
  return (
    <>
      {voices.voices.map((voice, at) => (
        <span key={voice.id} className={classes.slotFilled}>
          <UnstyledButton
            className={classes.slotChosen}
            aria-label={`Voice ${at + 1}: ${voice.name}`}
            disabled={voices.disabled}
            onClick={voices.onOpen}
          >
            <span className={classes.mediaName}>{voice.name}</span>
            {voices.tagged ? <span className={classes.tag}>@Voice{at + 1}</span> : null}
          </UnstyledButton>
          <UnstyledButton
            className={classes.thumbRemove}
            aria-label={`Remove ${voice.name}`}
            onClick={() => voices.onRemove(voice.id)}
          >
            <X size={14} strokeWidth={2.5} aria-hidden />
          </UnstyledButton>
        </span>
      ))}
      <UnstyledButton
        className={classes.slot}
        aria-label="Voices"
        disabled={voices.disabled}
        onClick={voices.onOpen}
      >
        <Mic size={20} strokeWidth={1.5} aria-hidden />
        <span className={classes.slotLabel}>Voices</span>
      </UnstyledButton>
    </>
  );
}
